import ConsciousnessChapter from './ConsciousnessChapter';
export default ConsciousnessChapter;
